// types
import { i18nHomePage } from 'models/i18n';

// ==============================|| I18N EN NAVIGATION ||============================== //

const enHomePage: i18nHomePage = {
  title: 'Energy Management System EMS - AI EMS',
  emsPartyName: 'EMS Party name',
  accountType: 'Account type',
  roles: 'Roles',
  dateTime: 'Date',
  AIEMSDescription:
    'AIEMS is a software solution - Energy Management System (EMS) utilizing elements of artificial intelligence (AI) that allows its user access to wholesale and balancing energy markets in real-time. It provides decision-making algorithms and tools for leveraging the energy capacities of managed resources to maximize returns from providing energy services, thereby optimizing consumption and production, improving network resilience, virtual energy storage, and accurate forecasts of price behavior and developments in the electricity market.',
  appDescription:
    'On the left side of the screen, there is a menu, and in the top right corner, it is possible to change the language, change the subject under which the user is logged in, or log out.'
};

export default enHomePage;
